module.exports = __webpack_public_path__ + "static/media/ax.15ebf0e2.svg";